import './App.scss'
import Scheduler from './components/Scheduler/Scheduler'
import { Provider } from 'react-redux'
import { store } from './store/store'

function App(): any {
  return (
    <div className='App'>
      <Provider store={store}>
        <Scheduler />
      </Provider>
    </div>
  )
}

export default App
